import React from "react";
import AdminLayout from "./AdminLayout";


function AdminHome() {
 return (
    <AdminLayout>
      <div>
        <h1>Admin Home</h1>
      </div>
    </AdminLayout>
  );
}

export default AdminHome;
